const cookies = {
  message: `<div align="justify">
    <p>
        <b>GLOSPEN, SL</b> use
        <b>
            <i>&quot;COOKIES&quot;</i>
        </b> to guarantee the correct functioning of our portal
        web, improving security, for superior efficiency and customization, for
        collect statistical data and to show you relevant advertising.
    </p>
    <p>
        If you continue browsing or press the button
        <b>&quot;ACCEPT&quot;</b> We will consider that you accept all its use.
        You can get more information in our
        <a
        href="/cookies/en"
        target="_blank"
        >COOKIES POLICY</a> in the footer.
    </p>
</div>`,
  content: `<ol>
    <div>
        <li class="body-2 font-weight-bold pb-2">WHAT ARE COOKIES?</li>
        <p style="text-align: justify" class="body-1">
            Cookies are small data files received by the terminal from the website
            visited and are used to record certain navigation interactions on a website
            storing data that can be updated and retrieved. These files are stored
            on the user's computer and contains anonymous data that is not harmful to its
            team. They are used to remember user preferences, such as the selected language,
            access data or personalization of the page.
        </p>
        <p style="text-align: justify" class="body-1">
            Cookies can also be used to record anonymous information about how a
            visitor uses a site. For example, from which web page has he accessed, or if he has used a
            &quot;banner&quot; advertising to reach.
        </p>
    </div>
    <div>
        <li class="body-2 font-weight-bold pb-2">WHY DO WE USE COOKIES?</li>
        <p style="text-align: justify" class="body-1">
            <b>GLOSPEN, SL</b> uses cookies that are strictly necessary and essential for you to use our
            websites and allow you to move freely, use secure areas, customize options,
            etc. In addition,
            <b>GLOSPEN, SL</b> uses cookies that collect data related to the analysis of the use of the
            web. These are used to help improve customer service by measuring usage and
            performance of the page, to optimize and personalize it.
        </p>
        <p style="text-align: justify" class="body-1">
            Our sites may also have social networking links (such as Facebook or Twitter).
            <b>GLOSPEN, SL</b> does not control the cookies used by these external sites. For more
            information about cookies from social networks or other third party sites, we recommend that you review
            their own cookie policy.
        </p>
        <p
                style="text-align: justify"
                class="body-1"
        >This website uses &quot;cookies&quot; in the following manner:</p>
        <ul class="mb-3">
            <li style="text-align: justify" class="my-2">
                <b>Cookie de Google ANALYTICS:</b> Google ANALYTICS is a free service that offers
                Google Inc. and which collects information about which pages of the website are consulted, at what time, what
                Web browser, etc. This information is then sent to Google Inc.
                in the United States.
            </li>
            <li style="text-align: justify" class="my-2">
                <b>Application Cookies &quot;Add-this&quot;:</b> Add-this is a free service that allows you to share
                pages of this website by different means (e-mail, social networks, etc.). Add-
                his collects statistical information about your browsing to provide advertising tailored to
                your browsing habits on this website or elsewhere.
            </li>
        </ul>
    </div>
    <div>
        <li
                class="body-2 font-weight-bold pb-2"
        >HOW DO WE USE THE DIFFERENT TYPES OF COOKIES?</li>
        <div class="body-2 font-weight-bold pb-2">According to its purpose:</div>
        <ul class="mb-3">
            <li style="text-align: justify" class="my-2">
                <b>Technical cookies:</b> Technical cookies are those that are indispensable and strictly
                necessary for the correct functioning of a web portal and the use of the different
                options and services offered. For example, those for the maintenance of
                session, response time management, performance or option validation, use
                security features, sharing content with social networks, etc.
            </li>
            <li style="text-align: justify" class="my-2">
                <b>Personalization cookies:</b> These cookies allow the user to specify or personalize
                some characteristics of the general settings of the website, e.g. defining the
                language, locale or browser type.
            </li>
            <li style="text-align: justify" class="my-2">
                <b>Analytical cookies:</b> Analytical cookies are those used by our website, to
                to elaborate navigation profiles and to be able to know the preferences of the users of the same one with the
                in order to improve the supply of products and services. For example, an analytical cookie is used to
                would control the geographical areas of greatest interest to a user, which is the most
                acceptance, etc.
            </li>
            <li style="text-align: justify" class="my-2">
                <b>Advertising/Advertising Cookies:</b> Advertising cookies allow the management of
                advertising spaces based on specific criteria. For example, the frequency of access, the
                edited content, etc. Advertising cookies allow through the management of the
                advertising store behavioral information through habit observation,
                studying the accesses and forming a profile of user preferences, to offer
                advertising related to your profile interests.
            </li>
        </ul>
        <div class="body-2 font-weight-bold pb-2">According to the deadline:</div>
        <ul class="mb-3">
            <li style="text-align: justify" class="my-2">
                <b>Session cookies:</b> Session cookies are those that last as long as the user
                is browsing the website and are deleted at the end.
            </li>
            <li style="text-align: justify" class="my-2">
                <b>Persistent cookies:</b> These cookies are stored in the user's terminal, by a
                longer time, making it easier to control the preferences chosen without having to repeat
                certain parameters each time the website is visited.
            </li>
        </ul>
    </div>
    <div>
        <li
                class="body-2 font-weight-bold pb-2"
        >WHAT IF I DON'T WANT TO HAVE THESE COOKIES OR DON'T DO ANYTHING ABOUT IT?</li>
        <p style="text-align: justify" class="body-1">
            In order to comply with current legislation, we have to ask your permission to manage cookies.
            If you decide not to authorize the treatment indicating the non-conformity, we would only use the cookies
            techniques, as they are essential for browsing our website. In this case, we do not
            stores no cookies. If you continue to browse our website without refusing
            your authorization implies that you accept its use.
        </p>
        <p style="text-align: justify" class="body-1">
            Please note that if you reject or delete web browsing cookies, we will not be able
            maintain your preferences, some features of the pages will not be operational, no
            we will be able to offer you personalized services and every time you go to browse our website
            we will have to ask again for your authorization for the use of cookies.
        </p>
        <p style="text-align: justify" class="body-1">
            If you still decide to change the configuration of your access to the website, you should know that it is
            you can delete the cookies or prevent this information from being recorded on your computer in
            any time by modifying the configuration parameters of your
            browser:
        </p>

        <ul class="mb-3">
            <li style="text-align: justify" class="my-2">
                <a
                        target="_blank"
                        href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies"
                >Internet Explorer cookie settings.</a>
            </li>
            <li style="text-align: justify" class="my-2">
                <a
                        target="_blank"
                        href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
                >Firefox cookie settings.</a>
            </li>
            <li style="text-align: justify" class="my-2">
                <a
                        target="_blank"
                        href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=es-419"
                >Google Chrome cookie settings.</a>
            </li>
            <li style="text-align: justify" class="my-2">
                <a
                        target="_blank"
                        href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
                >Safari cookie settings.</a>
            </li>
        </ul>
        <p style="text-align: justify" class="body-1">
            These browsers are subject to change or modification, so we cannot
            ensure that they are fully compliant with your browser version. It can also be
            using another browser not covered by these links such as Konqueror, Arora, Flock, etc.
            To avoid these mismatches, you can access directly from your browser options
            which is usually found in the Options menu, in the &quot;Privacy&quot; section.
            please refer to your browser help for more information :)
        </p>
    </div>
    <div>
        <li class="body-2 font-weight-bold pb-2">WHERE CAN I GET MORE INFORMATION?</li>
        <p
                style="text-align: justify"
                class="body-1"
        >You can find more information about cookies at:</p>

        <a target="_blank" href="https://www.allaboutcookies.org">www.allaboutcookies.org</a> or
        <a
                target="_blank"
                href="https://www.youronlinechoices.eu"
        >www.youronlinechoices.eu.</a>
    </div>
</ol>`,
}
export default cookies
